import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import welcome from './welcome.module'
import bill from './bill.module'
import payment from './payment.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    welcome,
    bill,
    payment
  },
  plugins: [createPersistedState()]
})



// WEBPACK FOOTER //
// ./src/store/index.js